import { render, staticRenderFns } from "./DetailCompanyProduct.vue?vue&type=template&id=2258766b&scoped=true&"
import script from "./DetailCompanyProduct.vue?vue&type=script&lang=js&"
export * from "./DetailCompanyProduct.vue?vue&type=script&lang=js&"
import style0 from "./DetailCompanyProduct.vue?vue&type=style&index=0&id=2258766b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2258766b",
  null
  
)

export default component.exports